import React from 'react';
import { Container } from '@src/elements/Grid';
import { COLOR_OUTERSPACE } from '@src/types/colors';
import { ButtonLinkStandard } from '../ButtonLink';
import styles from './VcdLink.module.scss';

interface VcdLink {
  documentUrl?: string;
}

const VcdLink: React.FC<VcdLink> = ({ documentUrl }) => {
  return (
    <Container>
      <div className={styles.vcdLink}>
        <ButtonLinkStandard
          className={styles.vcdLinkButton}
          color={COLOR_OUTERSPACE}
          href={documentUrl}
          openNewWindow
          boxIcon="right-arrow-alt"
          iconPosition="right"
        >
          Click to view the Village Comparison Document (VCD)
        </ButtonLinkStandard>
      </div>
    </Container>
  );
};

export default VcdLink;
